<template>
  <div class="digital-lecture-detail-speaker-list">
    <h2 class="title">
      {{ speakers.length > 1 ? 'Спикеры' : 'Спикер' }}
    </h2>
    <ul class="list">
      <li v-for="speaker in speakers" :key="speaker.id" class="item">
        <NuxtLink class="image-wrapper" :to="speaker.url">
          <img :src="speaker.photo" :alt="fullName(speaker)">
        </NuxtLink>

        <div class="info">
          <NuxtLink class="name" :to="speaker.url">
            {{ fullName(speaker) }}
          </NuxtLink>
          <span v-if="speaker.position" class="position">{{ speaker.position }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import type { DigitalLectureSpeaker } from '~/models/digital-lecture'

  defineProps<{
    speakers: DigitalLectureSpeaker[]
  }>()

  function fullName(speaker: DigitalLectureSpeaker): string {
    return [speaker.name, speaker.middle_name, speaker.last_name]
      .filter(Boolean)
      .join(' ')
  }
</script>

<style lang="scss" scoped>
  .digital-lecture-detail-speaker-list {
    @extend %flex-column;

    gap: 16px;

    > .title {
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      margin: 0;

      @include vp-767 {
        font-size: 20px;
        line-height: 28px;
      }
    }

    > .list {
      @extend %flex-column;

      gap: 16px;
      padding: 0;
      margin: 0;
      list-style: none;
    }

    > .list > .item {
      display: flex;
      gap: 20px;

      @include vp-767 {
        flex-direction: column;
        gap: 12px;
      }

      > .image-wrapper {
        overflow: hidden;
        display: flex;
        align-items: flex-end;
        width: 86px;
        min-width: 86px;
        border-radius: 12px;
        background-color: $color-default-white;

        @include vp-767 {
          width: 100%;
          height: 132px;
          border-radius: 20px;
        }

        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;

          @include vp-767 {
            object-fit: contain;
          }
        }
      }

      > .info {
        @extend %flex-column;

        flex-grow: 1;
        gap: 8px;
        padding: 16px;
        border-radius: 12px;
        background-color: $color-default-white;

        @include vp-767 {
          padding: 12px;
        }

        > .name {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          transition: color 0.3s ease-in-out;
          color: $color-default-black;
          text-decoration: none;

          @media (hover: hover) {
            &:hover {
              color: $color-kiwi-50;
            }
          }
        }

        > .position {
          font-size: 14px;
          line-height: 22px;
          color: $color-potato-70;
        }
      }
    }
  }
</style>
